import styled from 'styled-components';
import { palette } from '@landr/maestro';

const FadeToAppBackground = styled.div`
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 100%;
    background: linear-gradient(
        180deg,
        ${palette('neutral.1000', 0.68)} 0%,
        ${palette('neutral.1000', 0.792)} 53.38%,
        ${palette('neutral.1000')} 100%
    );
`;

export default FadeToAppBackground;
